import { useEffect, useState } from "react";
import { Button } from "src/@/components/ui/button";
import { Select, SelectTrigger, SelectValue, SelectContent, SelectItem } from "src/@/components/ui/select";
import { Card, CardHeader, CardContent } from "src/@/components/ui/card";
import v2_actionConfigCrm from "src/actions/v2/crm/v2_actionConfigCrm";
import useAuth from "src/hooks/useAuth";

const CardReactionMoverCardFunil = ({
  block,
  changeBlock
}) => {
  const { cliente } = useAuth();
  const [selectedPipe, setSelectedPipe] = useState(null);
  const [selectedPhase, setSelectedPhase] = useState(null); // Use null instead of an empty string
  const [configCrm, setConfigCrm] = useState(null);
  const [isSelectingPipe, setIsSelectingPipe] = useState(false);

  console.log('block', block);


  async function buscarConfigCrm(querys) {
    try {
      const result = await v2_actionConfigCrm(cliente._id, querys);
      if (result.data.data) {
        setConfigCrm(result.data.data);
      }
    } catch (error) {
      console.log(error);
    }
  }


  useEffect(() => {
    if(block?.data){
      let querys = `?pipeline_id=${block?.data?.pipelineId}`;
      buscarConfigCrm(querys);
      setIsSelectingPipe(true);
    } else {
      buscarConfigCrm();
    }

  }, [])



  return (
    <div className="w-full">
        <div className="space-y-4">
          {/* Pipe Selection */}
          <div>
            <label className="block text-sm font-medium">No funil</label>
            <Select
              value={block?.data?.pipelineId}
              onValueChange={e => {
                let event = {
                  name: "pipelineId",
                  value: e
                }
                changeBlock(event)
                let querys = `?pipeline_id=${e}`;
                buscarConfigCrm(querys);
                setIsSelectingPipe(true);
              }}>
              <SelectTrigger className="w-full">
                <SelectValue placeholder={block?.data?.pipelineId} />
              </SelectTrigger>
              <SelectContent>
                {configCrm?.pipelines.map((pipe) => (
                  <SelectItem key={pipe._id} value={pipe._id}>
                    {pipe.nome}
                  </SelectItem>
                ))}

                {/* Add more options if needed */}
              </SelectContent>
            </Select>
          </div>
          {/* Phase Selection */}
          {isSelectingPipe && (
            <div>
              <label className="block text-sm font-medium">Estágio</label>
              <Select 
              value={block?.data?.stageId}
              onValueChange={e => {
                let event = {
                  name: "stageId",
                  value: e
                }
                changeBlock(event)
              }}>
                <SelectTrigger className="w-full">
                  <SelectValue placeholder={selectedPhase ? selectedPhase : "Selecione..."} />
                </SelectTrigger>
                <SelectContent>
                  {/* Add valid phase options */}
                  {configCrm?.stages.map((stage) => (
                    <SelectItem key={stage._id} value={stage._id}>
                      {stage.nome}
                    </SelectItem>
                  ))}

                </SelectContent>
              </Select>
            </div>
          )}
        </div>
    </div>
  );
};

export default CardReactionMoverCardFunil;
